import { Grid2, Typography } from "@mui/material";
import { Fragment } from "react";
import Reasons, { reasonUI } from "./Reasons";
import OtherReason, { otherReasonUI } from "./OtherReason";
import useUIBp from "../../../../../../../../Hooks/useUIBoilerplate";
import SlimAlert from "../../../../../../../UI/GeneralPurpose/SlimAlert";

const UIText = {
  "es-CL": { subtitle4: "Motivo de la solicitud" },
  "en-US": { subtitle4: "Reason for the request" },
};

const Reason = () => {
  const { settings, UI } = useUIBp();
  const locale = settings.locale;
  const { subtitle4 } = UIText[locale];
  const reason = UI[reasonUI] ?? "";

  const { error } = UI[otherReasonUI] ?? {};

  return (
    <Fragment>
      <Grid2 container size={12}>
        <Typography fontWeight="bold">{subtitle4}</Typography>
      </Grid2>
      <Reasons />
      {reason === "Otro" ? <OtherReason /> : null}
      <SlimAlert {...{ errors: [error], size: 12 }} />
    </Fragment>
  );
};

export default Reason;
